<template>
  <v-container
    class="text-center"
    fill-height
  >
    <v-row align="center">
      <v-col>
        <h1 class="display-1 primary--text">Whoops</h1>

        <p>You do not have access to this page.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'NoAccess',
    created () {
      this.$ssrContext && this.$ssrContext.res.status(404)
    },
  }
</script>